import { defineStore } from 'pinia'
import { showMessage } from '@/common/utils'
import { apiAssetsList } from '@/api/assets'

export const useAssetsStore = defineStore('assets', {
  state: () => ({
    isLoading: false,
    assetsList: [],
    pageIndex: 0,
    hasMore: true
  }),
  getters: {},
  actions: {
    async fetchAssetsList() {
      return new Promise<any>((resolve, reject) => {
        if (this.isLoading || !this.hasMore) {
          return
        }
        this.isLoading = true
        apiAssetsList({ page: this.pageIndex, page_size: 20 })
          .then((data) => {
            let list = data.tasks
            for (let item of list) {
              // 服务端返回的数据结构，视频也是 image_url 和 image_id
              item.is_video = item.image_id.toLowerCase().endsWith('.mp4')
            }
            if (list.length > 0) {
              this.assetsList.push(...list)
            }
            this.pageIndex++
            this.hasMore = this.assetsList.length < data.total
            resolve(list)
          })
          .catch((err) => {
            showMessage(err, 'error')
          }).finally(() => {
            this.isLoading = false
          })
      })
    },
    async refreshAssetsList() {
      this.clearData()
      this.fetchAssetsList()
    },
    clearData() {
      this.isLoading = false
      this.assetsList = []
      this.pageIndex = 0
      this.hasMore = true
    },
  },
})
